<div class="page-input-container">
	<div class="page-input-page">
		<input type="text" placeholder="#" name="page" [(ngModel)]="pages" (ngModelChange)="onChangeHandler()" pattern="^((?!(0[0-9]))[\d]{1,2})$" maxlength="2" required>
	</div>
	<div class="page-input-fraction">
		<input type="text" placeholder="#" name="fraction" [(ngModel)]="fraction" (ngModelChange)="onChangeHandler()"  pattern="[0-7]" maxlength="1" required>
	</div>
	<div class="page-input-eigth">/ 8</div>
</div>





